import { createContext, useContext } from 'react';

const TaskContext = /*#__PURE__*/createContext("input");
const TaskMeta = /*#__PURE__*/createContext({
  taskId: "",
  taskEntryKey: ""
});
function useTaskContext() {
  return useContext(TaskContext);
}
function useTaskMeta() {
  return useContext(TaskMeta);
}

export { TaskContext, TaskMeta, useTaskContext, useTaskMeta };
//# sourceMappingURL=context.js.map
